import { render, staticRenderFns } from "./Blogroll.vue?vue&type=template&id=41805a48&scoped=true"
import script from "./Blogroll.vue?vue&type=script&lang=js"
export * from "./Blogroll.vue?vue&type=script&lang=js"
import style0 from "./Blogroll.vue?vue&type=style&index=0&id=41805a48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41805a48",
  null
  
)

export default component.exports